/**
 * Scroll a row into view WITHOUT touching the page scroll.
 *
 * `Element.scrollIntoView` walks every scrollable ancestor including the document, so revealing a
 * row deep in a rail also yanks the whole page — the same bug the session viewer's thread hit. This
 * nudges only the nearest scrolling ancestor, and only far enough.
 */

function nearestScroller(el: HTMLElement): HTMLElement | null {
  for (let node = el.parentElement; node; node = node.parentElement) {
    const overflowY = getComputedStyle(node).overflowY;
    if (
      (overflowY === 'auto' || overflowY === 'scroll') &&
      node.scrollHeight > node.clientHeight
    ) {
      return node;
    }
  }
  return null;
}

export function revealInScroller(target: HTMLElement | null): void {
  if (!target) return;
  const viewport = nearestScroller(target);
  if (!viewport) return;
  const vp = viewport.getBoundingClientRect();
  const t = target.getBoundingClientRect();
  if (t.top < vp.top) {
    viewport.scrollTop -= vp.top - t.top;
  } else if (t.bottom > vp.bottom) {
    // A tall row (one with its detail open) is pinned to the TOP rather than the bottom: scrolling
    // its last pixel into view would leave the row's own name off-screen above.
    viewport.scrollTop +=
      t.height > vp.height ? t.top - vp.top : t.bottom - vp.bottom;
  }
}
